import { render, staticRenderFns } from "./jobFrom.vue?vue&type=template&id=3052763f&scoped=true"
import script from "./jobFrom.vue?vue&type=script&lang=js"
export * from "./jobFrom.vue?vue&type=script&lang=js"
import style0 from "./jobFrom.vue?vue&type=style&index=0&id=3052763f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052763f",
  null
  
)

export default component.exports